/**
 * Compact "X ago" relative time helper — stable, SSR-safe, no deps.
 * Returns "—" for null/undefined/invalid dates.
 */
export const timeAgo = (input) => {
  if (!input) return '—';
  let d;
  try {
    d = input instanceof Date ? input : new Date(input);
  } catch {
    return '—';
  }
  const ms = Date.now() - d.getTime();
  if (Number.isNaN(ms)) return '—';
  if (ms < 0) return 'just now';
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w ago`;
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

/**
 * Prefix-formatted: "Updated 3h ago"
 */
export const lastUpdated = (input, prefix = 'Updated') => {
  const rel = timeAgo(input);
  if (rel === '—') return '';
  return `${prefix} ${rel}`;
};
